import mitt from "mitt";

const localEventBus = mitt();

export default localEventBus;